import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          numbersBlacklistQueue {
            id,
            wait_until,
            blacklisted_at,
            customer {
              id,
              name,
              phone_number
            }
          }
        }
      `
    })
  },
  add(customerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createNumberBlacklistQueue (
            customerId: ${customerId}
          ) {
            id,
            wait_until,
            blacklisted_at,
            customer {
              id,
              name,
              phone_number
            }
          }
        }
      `
    })
  },
  update(numberBlacklist) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateNumberBlacklistQueue (
            id: ${numberBlacklist.id},
          ) {
            id,
            wait_until,
            blacklisted_at,
            customer {
              id,
              name,
              phone_number
            }
          }
        }
      `
    })
  },
  delete(numberBlacklistId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteNumberBlacklistQueue (
            id: ${numberBlacklistId}
          )
        }
      `
    })
  },
  block(numberBlacklistId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          blockNumberFromBlacklist (
            id: ${numberBlacklistId},
          ) {
            id,
            wait_until,
            blacklisted_at,
            customer {
              id,
              name,
              phone_number
            }
          }
        }
      `
    })
  },
}
